import RepositoryFactory from "@/builder/apis";
const utilities = RepositoryFactory.utilities;

export default {
  uploadFiles({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await utilities.uploadFiles(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
